
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsTaxInvoiceAddressGrid extends Serenity.EntityGrid<PsTaxInvoiceAddressRow, any> {
        protected getColumnsKey() { return PsTaxInvoiceAddressColumns.columnsKey; }
        protected getDialogType() { return PsTaxInvoiceAddressDialog; }
        protected getIdProperty() { return PsTaxInvoiceAddressRow.idProperty; }
        protected getInsertPermission() { return PsTaxInvoiceAddressRow.insertPermission; }
        protected getLocalTextPrefix() { return PsTaxInvoiceAddressRow.localTextPrefix; }
        protected getService() { return PsTaxInvoiceAddressService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}